import styled from "@emotion/styled"
import { library } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { navigate } from "gatsby"
import qs from "qs"
import React, { useState } from "react"
import tw from "twin.macro"

library.add(
  faSearch
)

const InputWrapper = styled.div`
  ${tw`relative`}
`

const InputField = styled.input`
  ${tw`rounded-full py-1 pl-8 pr-4 focus:border-teal-darker text-gray w-full`}
`

const Button = styled.button`
  ${tw`absolute inset-y-0 left-0 pl-2 flex items-center text-teal`}
`

const HeaderSearch = () => {
  const [query, setQuery] = useState()

  return (
    <form
      action="/search"
      method="get"
      onSubmit={(event) => {
        if ((window.location.pathname || "").indexOf("/search") === -1) {
          event.preventDefault()
          navigate(`/search?${qs.stringify({ query })}`, { replace: true })
        }
      }}
    >
      <InputWrapper>
        <InputField
          type="text"
          name="query"
          aria-label="Search laitram.com"
          placeholder="Search laitram.com"
          autocorrect="off"
          autocapitalize="off"
          autocomplete="off"
          spellcheck="false"
          onKeyUp={(event) => {
            setQuery(event.target.value)
          }}
        />
        <Button type="submit" aria-label="Submit Search">
          <FontAwesomeIcon icon={["fas", "search"]} />
        </Button>
      </InputWrapper>
    </form>
  )
}

export default HeaderSearch
